import CapabilitiesInvoiceHOC from './CapabilitiesInvoice.HOC';
import CapabilitiesInvoiceView from './CapabilitiesInvoice.view';

const CapabilitiesInvoice = CapabilitiesInvoiceHOC(CapabilitiesInvoiceView);

export { CapabilitiesInvoice };
